export const UPDATE_PEOPLE_NUMBER = 'UPDATE_PEOPLE_NUMBER';
export const SET_DEMOGRAPHIC_DATA = 'SET_DEMOGRAPHIC_DATA';
export const SET_DEMOGRAPHIC_LOADING = 'SET_DEMOGRAPHIC_LOADING';
export const UPDATE_DEMOGRAPHIC_ITEM_HEIGHT = 'UPDATE_DEMOGRAPHIC_ITEM_HEIGHT';
export const SET_DEMOGRAPHIC_DEFAULT_DATA = 'SET_DEMOGRAPHIC_DEFAULT_DATA';
export const SET_DEMOGRAPHIC_SPENDING_DATA = 'SET_DEMOGRAPHIC_SPENDING_DATA';
export const SAVE_GROUPS = 'SAVE_GROUPS';
